<template>
  <div>
    <c-section-header :data="heading" class="center-content" />
    <fragment>
      <iframe style="border:none;" src="https://recruitcrm.io/talent_pool_submission/campuskraft"></iframe>
    </fragment>
  </div>
</template>

<script>
import CLayout from "@/layouts/LayoutAlternative.vue";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
export default {
  name: "Application",
  components: {
    CSectionHeader,
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  computed: {
    heading() {
      return {
        title: this.$i18n.t("application.heading"),
      };
    },
  },
};
</script>

<style scoped>
.section-header {
  padding-bottom: 0px;
}
@media (max-width: 600px) {
  .section-header {
    margin-top: 120px;
    padding-bottom: 0px;
  }
  iframe {
    height: 2500px;
    width: 90vw;
    margin-left: 5%;
  }
}
@media (min-width: 600px) {
  iframe {
    height: 1680px;
    width: 900px;
    max-width: 90%;
    max-height: 90%;
    margin-top: 40px;
    margin-left: 20%;
    overflow-x: hidden;
  }
}
@media (min-width: 641px) {
  .section-header {
    margin-top: 160px;
    padding-bottom: 0px;
  }
}
</style>

